import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckValue } from '../../services/types/Misc';
import CheckBox from './CheckBox';

interface Props {
  elements: { id: string; name: string }[];
  selected: string[];
  setSelected: (id: string, value: boolean) => void;
  translate?: boolean;
}

const DropdownChecks: React.FC<Props> = ({ elements, selected, setSelected, translate = true }) => {
  const { t } = useTranslation();

  const checks = elements.map((x) => ({
    id: x.id || 'id',
    text: translate ? t(x.name || '') : x.name || '',
    htmlId: `chk${x.id}`,
    checked: selected.indexOf(x.id || '') !== -1,
  }));
  const columnCheck = (element: CheckValue) => (
    <CheckBox key={element.id} element={element} onChange={setSelected} />
  );

  return <div className="cols-container">{checks.map((c) => columnCheck(c))}</div>;
};

export default React.memo(DropdownChecks);
